import React, {PropTypes} from "react"
import { Form, Row } from "antd"
import "./materialForm.scss"

export default class MaterialForm extends React.Component {
  render() {
    let { justify, align } = this.props
    return (
      <Form>
        <Row className="pgx-form material-form" type="flex" justify={justify} align={align}>
          {this.props.children}
        </Row>
      </Form>
    )
  }
}

MaterialForm.propTypes = {
  justify: PropTypes.string
}

MaterialForm.defaultProps = {
  justify: "center",
  align: "middle"
}



// WEBPACK FOOTER //
// ./src/app/components/normal/MaterialForm/MaterialForm.js